import { Link } from "react-router-dom"
import "./About.css"
import PlayStoreIcon from "../img/playstore.png"
import AppStoreIcon from "../img/appstore.png"
import Logo from "../img/logo3.png"

const About = () => {
  return (
    <div className="about-page">
      {/* Header */}
      <header className="about-header">
        <div className="header-content">
          <div className="logo-section">
            <Link to="/" className="logo-link">
              <img src={Logo || "/placeholder.svg"} alt="Yupluck" className="logo-img" />
              <span className="logo-text">Yupluck</span>
            </Link>
          </div>

          <nav className="nav-menu">
            <Link to="/" className="nav-item">
              Home
            </Link>
            <Link to="/about" className="nav-item active">
              About
            </Link>
            
          </nav>

          <div className="header-actions">
            <Link to="/login" className="btn-outline">
              Sign In
            </Link>
            <Link to="/register" className="btn-primary">
              Get Started
            </Link>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="about-hero">
        <div className="hero-background">
          <div className="hero-shapes">
            <div className="shape shape-1"></div>
            <div className="shape shape-2"></div>
            <div className="shape shape-3"></div>
          </div>
        </div>

        <div className="ab-container">
          <div className="hero-content">
            <div className="hero-badge">
              <span className="badge-icon">💪</span>
              <span>About Yupluck</span>
            </div>

            <h1 className="hero-title">
              Where Fitness Meets
              <span className="gradient-text"> Social Connection</span>
            </h1>

            <p className="hero-description">
              Yupluck is revolutionizing the fitness industry by combining gym booking convenience with social media
              engagement. We're not just an app - we're a community of fitness enthusiasts supporting each other's
              journey.
            </p>

            <div className="hero-stats">
              <div className="stat-card">
                <div className="stat-icon">🏋️‍♂️</div>
                <div className="stat-number">Smart Booking</div>
                <div className="stat-label">Gym Reservations</div>
              </div>
              <div className="stat-card">
                <div className="stat-icon">📱</div>
                <div className="stat-number">Social Platform</div>
                <div className="stat-label">Fitness Community</div>
              </div>
              <div className="stat-card">
                <div className="stat-icon">🎥</div>
                <div className="stat-number">Workout Reels</div>
                <div className="stat-label">Share Progress</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What is Yupluck Section */}
      <section className="what-is-yupluck">
        <div className="ab-container">
          <div className="section-content">
            <div className="content-left">
              <div className="section-tag">
                <span className="tag-icon">🚀</span>
                <span>What is Yupluck?</span>
              </div>

              <h2 className="section-title">
                The Ultimate
                <span className="highlight"> Fitness Ecosystem</span>
              </h2>

              <p className="section-description">
                Yupluck is a comprehensive fitness platform that seamlessly blends gym booking functionality with social
                media features. Whether you're looking to reserve your favorite workout slot or share your fitness
                journey with friends, we've got you covered.
              </p>

              <div className="feature-highlights">
                <div className="highlight-item">
                  <div className="highlight-icon">🎯</div>
                  <div className="highlight-content">
                    <h4>Smart Gym Booking</h4>
                    <p>Book gym slots instantly with real-time availability and smart scheduling.</p>
                  </div>
                </div>

                <div className="highlight-item">
                  <div className="highlight-icon">👥</div>
                  <div className="highlight-content">
                    <h4>Social Fitness Network</h4>
                    <p>Connect with workout buddies, share progress, and motivate each other.</p>
                  </div>
                </div>

                <div className="highlight-item">
                  <div className="highlight-icon">🎬</div>
                  <div className="highlight-content">
                    <h4>Workout Reels</h4>
                    <p>Upload and share your workout videos to inspire the community.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="content-right">
              <div className="feature-showcase">
                <div className="showcase-card card-1">
                  <div className="card-header">
                    <div className="card-icon">🏋️‍♂️</div>
                    <h3>Gym Booking</h3>
                  </div>
                  <p>Reserve your workout slots with ease</p>
                  <div className="card-features">
                    <span>✓ Real-time availability</span>
                    <span>✓ Instant confirmation</span>
                    <span>✓ Easy rescheduling</span>
                  </div>
                </div>

                <div className="showcase-card card-2">
                  <div className="card-header">
                    <div className="card-icon">📱</div>
                    <h3>Social Features</h3>
                  </div>
                  <p>Connect and share with fitness community</p>
                  <div className="card-features">
                    <span>✓ Upload workout reels</span>
                    <span>✓ Follow friends</span>
                    <span>✓ Share achievements</span>
                  </div>
                </div>

                <div className="showcase-card card-3">
                  <div className="card-header">
                    <div className="card-icon">🎯</div>
                    <h3>Progress Tracking</h3>
                  </div>
                  <p>Monitor your fitness journey</p>
                  <div className="card-features">
                    <span>✓ Workout analytics</span>
                    <span>✓ Goal setting</span>
                    <span>✓ Achievement badges</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Core Features Section */}
      <section className="core-features">
        <div className="ab-container">
          <div className="section-header">
            <div className="section-tag">
              <span className="tag-icon">⚡</span>
              <span>Core Features</span>
            </div>
            <h2 className="section-title">Everything You Need in One Platform</h2>
            <p className="section-description">
              From booking your next gym session to sharing your fitness milestones, Yupluck provides all the tools you
              need for a successful fitness journey.
            </p>
          </div>

          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-visual">
                <div className="visual-icon">🏋️‍♂️</div>
                <div className="visual-bg"></div>
              </div>
              <div className="feature-content">
                <h3>Instant Gym Booking</h3>
                <p>
                  Book your favorite gym slots in seconds. Check real-time availability, choose your preferred time,
                  and get instant confirmation.
                </p>
                <ul className="feature-list">
                  <li>Real-time slot availability</li>
                  <li>Multiple gym locations</li>
                  <li>Flexible booking options</li>
                  <li>Easy cancellation policy</li>
                </ul>
              </div>
            </div>

            <div className="feature-card">
              <div className="feature-visual">
                <div className="visual-icon">🎥</div>
                <div className="visual-bg"></div>
              </div>
              <div className="feature-content">
                <h3>Workout Reels & Content</h3>
                <p>
                  Share your workout videos, transformation stories, and fitness tips with the community. Upload reels
                  to inspire and get inspired.
                </p>
                <ul className="feature-list">
                  <li>Upload workout videos</li>
                  <li>Share transformation pics</li>
                  <li>Create fitness content</li>
                  <li>Engage with community</li>
                </ul>
              </div>
            </div>

            <div className="feature-card">
              <div className="feature-visual">
                <div className="visual-icon">👥</div>
                <div className="visual-bg"></div>
              </div>
              <div className="feature-content">
                <h3>Social Fitness Network</h3>
                <p>
                  Connect with like-minded fitness enthusiasts, find workout partners, and build lasting friendships
                  through shared fitness goals.
                </p>
                <ul className="feature-list">
                  <li>Find workout buddies</li>
                  <li>Join fitness groups</li>
                  <li>Follow friends' progress</li>
                  <li>Motivate each other</li>
                </ul>
              </div>
            </div>

            <div className="feature-card">
              <div className="feature-visual">
                <div className="visual-icon">📊</div>
                <div className="visual-bg"></div>
              </div>
              <div className="feature-content">
                <h3>Progress Tracking</h3>
                <p>
                  Monitor your fitness journey with detailed analytics, set goals, and celebrate achievements with the
                  community.
                </p>
                <ul className="feature-list">
                  <li>Workout analytics</li>
                  <li>Goal setting & tracking</li>
                  <li>Achievement badges</li>
                  <li>Progress sharing</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision Section */}
      <section className="mission-vision">
        <div className="ab-container">
          <div className="mission-content">
            <div className="mission-left">
              <div className="section-tag">
                <span className="tag-icon">🎯</span>
                <span>Our Mission</span>
              </div>

              <h2 className="mission-title">
                Making Fitness
                <span className="highlight"> Social & Accessible</span>
              </h2>

              <p className="mission-description">
                Our mission is to revolutionize the fitness industry by creating a platform where convenience meets
                community. We believe that fitness is more enjoyable and sustainable when shared with others.
              </p>

              <div className="mission-points">
                <div className="point-item">
                  <div className="point-icon">🌟</div>
                  <div className="point-content">
                    <h4>Accessibility</h4>
                    <p>Making gym booking and fitness tracking accessible to everyone, everywhere.</p>
                  </div>
                </div>

                <div className="point-item">
                  <div className="point-icon">🤝</div>
                  <div className="point-content">
                    <h4>Community</h4>
                    <p>Building a supportive community where fitness enthusiasts motivate each other.</p>
                  </div>
                </div>

                <div className="point-item">
                  <div className="point-icon">🚀</div>
                  <div className="point-content">
                    <h4>Innovation</h4>
                    <p>Continuously innovating to provide the best fitness experience possible.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="mission-right">
              <div className="vision-card">
                <div className="vision-header">
                  <div className="vision-icon">🔮</div>
                  <h3>Our Vision</h3>
                </div>
                <p>
                  To become the world's leading social fitness platform, where every workout is an opportunity to
                  connect, share, and grow together as a community.
                </p>

                <div className="vision-goals">
                  <div className="goal-item">
                    <span className="goal-number">01</span>
                    <span className="goal-text">Connect fitness enthusiasts globally</span>
                  </div>
                  <div className="goal-item">
                    <span className="goal-number">02</span>
                    <span className="goal-text">Simplify gym booking experience</span>
                  </div>
                  <div className="goal-item">
                    <span className="goal-number">03</span>
                    <span className="goal-text">Promote healthy lifestyle habits</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Yupluck Section */}
      <section className="why-choose">
        <div className="ab-container">
          <div className="section-header">
            <div className="section-tag">
              <span className="tag-icon">💎</span>
              <span>Why Choose Yupluck?</span>
            </div>
            <h2 className="section-title">The Perfect Blend of Convenience & Community</h2>
          </div>

          <div className="benefits-grid">
            <div className="benefit-card">
              <div className="benefit-icon">⚡</div>
              <h3>Lightning Fast Booking</h3>
              <p>Book your gym slots in under 30 seconds with our intuitive interface and real-time availability.</p>
            </div>

            <div className="benefit-card">
              <div className="benefit-icon">🎬</div>
              <h3>Share Your Journey</h3>
              <p>Upload workout reels, share progress photos, and inspire others with your fitness transformation.</p>
            </div>

            <div className="benefit-card">
              <div className="benefit-icon">👫</div>
              <h3>Find Workout Partners</h3>
              <p>Connect with fitness enthusiasts in your area and make working out a social, enjoyable experience.</p>
            </div>

            <div className="benefit-card">
              <div className="benefit-icon">📈</div>
              <h3>Track Your Progress</h3>
              <p>Monitor your fitness journey with detailed analytics and celebrate milestones with the community.</p>
            </div>

            <div className="benefit-card">
              <div className="benefit-icon">🏆</div>
              <h3>Achieve Together</h3>
              <p>Join challenges, earn badges, and achieve your fitness goals with support from the community.</p>
            </div>

            <div className="benefit-card">
              <div className="benefit-icon">🔒</div>
              <h3>Safe & Secure</h3>
              <p>Your data is protected with enterprise-grade security, ensuring a safe and private experience.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Download CTA Section */}
      <section className="download-cta">
        <div className="ab-container">
          <div className="cta-content">
            <div className="cta-background">
              <div className="cta-shapes">
                <div className="cta-shape cta-shape-1"></div>
                <div className="cta-shape cta-shape-2"></div>
              </div>
            </div>

            <div className="cta-text">
              <h2 className="cta-title">Ready to Transform Your Fitness Journey?</h2>
              <p className="cta-description">
                Join thousands of fitness enthusiasts who are already using Yupluck to book gyms, share workouts, and
                achieve their goals together.
              </p>
            </div>

            <div className="cta-actions">
              <a
                href="https://play.google.com/store/apps/details?id=com.yupluck.mepluck"
                target="_blank"
                rel="noopener noreferrer"
                className="download-btn"
              >
                <img src={PlayStoreIcon || "/placeholder.svg"} alt="Google Play" />
                <div className="btn-text">
                  <span className="btn-label">Download for</span>
                  <span className="btn-platform">Android</span>
                </div>
              </a>

              <a
                href="https://apps.apple.com/in/app/yupluck/id6737851845"
                target="_blank"
                rel="noopener noreferrer"
                className="download-btn"
              >
                <img src={AppStoreIcon || "/placeholder.svg"} alt="App Store" />
                <div className="btn-text">
                  <span className="btn-label">Download for</span>
                  <span className="btn-platform">iOS</span>
                </div>
              </a>
            </div>

            <div className="cta-guarantee">
              <div className="guarantee-icon">🛡️</div>
              <span>Free to download • No hidden fees • Join the community today</span>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="about-footer">
        <div className="ab-container">
          <div className="footer-content">
            <div className="footer-main">
              <div className="footer-brand">
                <div className="footer-logo">
                  <img src={Logo || "/placeholder.svg"} alt="Yupluck" />
                  <span>Yupluck</span>
                </div>
                <p className="footer-tagline">Your complete fitness ecosystem - book, track, share, and connect.</p>
              </div>

              <div className="footer-links">
                <div className="link-group">
                  <h4>Company</h4>
                  <ul>
                    <li>
                      <Link to="/about">About Us</Link>
                    </li>
                    <li>
                      <Link to="/contact">Contact Us</Link>
                    </li>
                  </ul>
                </div>

                <div className="link-group">
                  <h4>Account</h4>
                  <ul>
                    <li>
                      <Link to="/login">Sign In</Link>
                    </li>
                    <li>
                      <Link to="/register">Get Started</Link>
                    </li>
                  </ul>
                </div>

                <div className="link-group">
                  <h4>Download</h4>
                  <ul>
                    <li>
                      <a
                        href="https://play.google.com/store/apps/details?id=com.yupluck.mepluck"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Android App
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://apps.apple.com/in/app/yupluck/id6737851845"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        iOS App
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="footer-bottom">
              <div className="footer-copyright">
                <p>&copy; {new Date().getFullYear()} Yupluck. All rights reserved.</p>
              </div>
              <div className="footer-contact">
                <span>📧 contact@yupluck.com</span>
                <span>📞 Support available</span>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default About
